import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import { phoneNumberSchema } from './schemas/phoneNumberSchema';

export interface IInsurerAddEditValidated {
    name: string;
    paymentPeriod: number | null;
}

export const insurerAddEditSchema: ISchemaContainer<IInsurerAddEditValidated> = {
    schema: Koi.object({
        name: Koi.string().max(255),
        paymentPeriod: Koi.number().min(0).allow(null),
        phoneNumberCareMediation: Koi.when('turnoverCeilingStartDate', {
            is: Koi.koi().date(),
            otherwise: Koi.valid(null),
            then: phoneNumberSchema,
        }),
        turnoverCeilingEndDate: Koi.when('turnoverCeilingStartDate', {
            is: Koi.koi().date(),
            otherwise: Koi.valid(null),
            then: Koi.koi().date(),
        }),
        turnoverCeilingStartDate: Koi.koi().date().allow(null),
    }).options({ convert: false, presence: 'required' }),
};
